import styled from "styled-components";

export const LaunchSurface = styled.div`
  position: relative;
  width: 100%;
  min-height: calc(100vh - 180px);
  display: flex;
  align-items: center;
  padding: 32px 0 72px;
  // background: linear-gradient(180deg, rgba(250, 249, 255, 0.75) 0%, #faf9ff 100%);
  @media (max-width: 991px) {
    min-height: auto;
    padding: 24px 0 48px;
  }
`;

export const LaunchSurfaceContent = styled.div`
  position: relative;
  z-index: 2;
  width: 100%;
  max-width: 960px;
  margin: 0 auto;
  padding: 0 32px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 26px;
  @media (max-width: 991px) {
    padding: 0 16px;
    gap: 24px;
  }
`;

export const LaunchHeader = styled.div`
  text-align: center;
  width: 100%;
  h1 {
    font-size: 24px;
    line-height: 26px;
    font-weight: 600;
    color: ${({ theme }) => theme.settings.tertiary};
    margin: 0px;
  }
  p {
    font-size: 18px;
    line-height: 28px;
    color: ${({ theme }) => theme.settings.secondary};
    margin: 0;
  }
  @media (max-width: 575px) {
    h1 {
      font-size: 22px;
      line-height: 28px;
    }
    p {
      font-size: 16px;
      line-height: 24px;
    }
  }
`;

export const PromptSection = styled.div`
  width: 100%;
  max-width: 900px;
  margin: 0 auto;
`;


